import React from "react";
import { Breadcrumbs, Link } from "@mui/material";
import Utils from "../utils";
function ThemeBreadcrumbs({ className }) {
  const path = window.location.pathname.split("/").slice(1);
  var url = "";
  return (
    <Breadcrumbs aria-label="breadcrumb" className={className}>
      {path.length >= 1 ? (
        <Link className="text-sm" underline="hover" color="inherit" href="/">
          Home
        </Link>
      ) : (
        ""
      )}

      {path.slice(0, -1).map((link, index) => {
        url = url + "/" + link;
        return (
          <Link
            className="text-sm"
            underline="hover"
            color="inherit"
            href={url}
            key={index}
          >
            {link.toProperCase()}
          </Link>
        );
      })}

      {path.length < 1 ? (
        <Link
          underline="hover"
          color="text.primary"
          className="text-sm"
          href="/"
          aria-current="page"
        >
          Home
        </Link>
      ) : (
        <Link
          underline="hover"
          className="text-sm"
          color="text.primary"
          href={url + "/" + path.slice(-1)[0]}
          aria-current="page"
        >
          {path.slice(-1)[0].replace("-", " ").toProperCase()}
        </Link>
      )}
    </Breadcrumbs>
  );
}

export default ThemeBreadcrumbs;
